// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const Calendar = lazy(() => import('../../views/apps/calendar'))

const Roles = lazy(() => import('../../views/apps/roles-permissions/roles'))
const Permissions = lazy(() => import('../../views/apps/roles-permissions/permissions'))

const AcctgRptAcctStatement = lazy(() => import('../../views/apps/accounting/reports/AccountStatement'))
const AcctgRptInvoiceSumm = lazy(() => import('../../views/apps/accounting/reports/InvoiceSummary'))
const AcctgRptBillSumm = lazy(() => import('../../views/apps/accounting/reports/BillSummary'))
const AcctgRptProductStock = lazy(() => import('../../views/apps/accounting/reports/ProductStock'))
const AcctgRptProfitAndLoss = lazy(() => import('../../views/apps/accounting/reports/ProfitAndLoss'))
const AcctgRptTransactionSumm = lazy(() => import('../../views/apps/accounting/reports/TransactionSummary'))
const AcctgRptIncomeSumm = lazy(() => import('../../views/apps/accounting/reports/IncomeSummary'))
const AcctgRptExpenseSumm = lazy(() => import('../../views/apps/accounting/reports/ExpenseSummary'))
const AcctgRptIncomeVsExpense = lazy(() => import('../../views/apps/accounting/reports/IncomeVsExpense'))
const AcctgRptTaxSumm = lazy(() => import('../../views/apps/accounting/reports/TaxSummary'))

const ProdSvcEntry = lazy(() => import('../../views/apps/product/entries/ProdSvc'))
const CustomerEntry = lazy(() => import('../../views/apps/customer/entries/list'))
const VendorEntry = lazy(() => import('../../views/apps/vendor/entries/list'))
const AcctgEntryBankingAccount = lazy(() => import('../../views/apps/accounting/entries/banking/Account'))
const AcctgEntryBankingTransfer = lazy(() => import('../../views/apps/accounting/entries/banking/Transfer'))
const AcctgEntryCOA = lazy(() => import('../../views/apps/accounting/entries/ChartOfAccounts'))
const HRDailyTimeRecord = lazy(() => import('../../views/apps/humanresource/entries/DailyTimeRecord'))
const CatchAll = lazy(() => import('../../views/apps/catchall'))

const PrintSetting = lazy(() => import('../../views/apps/sys/printsetting'))

const AppRoutes = [
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/banking/Account'
  },
  {
    element: <AcctgEntryBankingTransfer />,
    path: '/apps/accounting/entries/banking/Transfer'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/income/Invoice'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/income/Revenue'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/income/CreditNote'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/expense/Bill'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/expense/Payment'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/expense/DebitNote'
  },

  {
    element: <AcctgEntryCOA />,
    path: '/apps/accounting/entries/ChartOfAccounts'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/JournalAcct'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/LedgerSumm'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/BalSheet'
  },
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/TrialBal'
  },  

  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/FinGoal'
  }, 
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/accounting/entries/AcctSetup'
  }, 
  {
    element: <AcctgEntryBankingAccount />,
    path: '/apps/config/PrintSetting'
  }, 

  {
    element: <HRDailyTimeRecord />,
    path: '/apps/humanresource/entries/DailyTimeRecord'
  },


  {
    element: <AcctgRptAcctStatement />,
    path: '/apps/accounting/reports/AccountStatement'
  },
  {
    element: <AcctgRptInvoiceSumm />,
    path: '/apps/accounting/reports/InvoiceSummary'
  },
  {
    element: <AcctgRptBillSumm />,
    path: '/apps/accounting/reports/BillSummary'
  },
  {
    element: <AcctgRptProductStock />,
    path: '/apps/accounting/reports/ProductStock'
  },
  {
    element: <AcctgRptProfitAndLoss />,
    path: '/apps/accounting/reports/ProfitAndLoss'
  },
  {
    element: <AcctgRptTransactionSumm />,
    path: '/apps/accounting/reports/TransactionSummary'
  },
  {
    element: <AcctgRptIncomeSumm />,
    path: '/apps/accounting/reports/IncomeSummary'
  },
  {
    element: <AcctgRptExpenseSumm />,
    path: '/apps/accounting/reports/ExpenseSummary'
  },
  {
    element: <AcctgRptIncomeVsExpense />,
    path: '/apps/accounting/reports/IncomeVsExpense'
  },
  {
    element: <AcctgRptTaxSumm />,
    path: '/apps/accounting/reports/TaxSummary'
  },

  {
    element: <ProdSvcEntry />,
    path: '/apps/product/entries/ProdSvc'
  },
  {
    element: <CustomerEntry />,
    path: '/apps/customer/entries/list'
  },
  {
    element: <VendorEntry />,
    path: '/apps/vendor/entries/list'
  },

  
  {
    element: <CatchAll />,
    path: '/apps/catchall'
  },

  {
    element: <PrintSetting />,
    path: '/apps/sys/printsetting'
  }
]

export default AppRoutes
